import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { GlobalActions } from 'core';
import { first } from 'rxjs/operators';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    private diagnosticApiUrl: string = '/api/Diagnostic';
    constructor(private injector: Injector) {}

    public handleError(error: Error | HttpErrorResponse): void {
        if (!(error instanceof HttpErrorResponse)) {
            this.postErrorToServer(error);
        }
        this.displayError(error);
    }

    private postErrorToServer(error: Error): void {
        const http = this.injector.get(HttpClient);
        http.post(this.diagnosticApiUrl, { message: error.message, stack: error.stack })
            .pipe(first())
            .subscribe();
    }

    private displayError(error: Error | HttpErrorResponse): void {
        if (!ETR.isProduction && !ETR.isCypress && !ETR.currentUserTraits.isHidingErrorsFromUserEnabledOnTestEnvironment) {
            if (typeof(error) === 'string') {
                GlobalActions.displayError(error);
            } else {
                GlobalActions.displayError(error.message);
            }
        }
        // eslint-disable-next-line no-console
        console.error(error);
    }
}
